import { usersActions } from "../../actionTypes";

const initialState = {
	user: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case usersActions.FETCH_USER: {
			return { ...initialState, fetching: true };
		}

		case usersActions.FETCH_USER_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				user: action.payload,
			};
		}

		case usersActions.FETCH_USER_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
